/* RESPONSIBLE TEAM: team-inbox */
import StepSerializer from '../step';

export default StepSerializer;
